import buildAsyncCall from './asyncCall'
import * as Helpers from './helpers'

const Types = {
    DASHBOARD_MINIVISION_SOUNDBARS_TOP: {
        request: 'DASHBOARD_MINIVISION_SOUNDBARS_TOP##REQUEST',
        success: 'DASHBOARD_MINIVISION_SOUNDBARS_TOP##SUCCESS',
        failure: 'DASHBOARD_MINIVISION_SOUNDBARS_TOP##FAILURE',
    },
    DASHBOARD_MINIVISION_DWELLTIMELINE: {
        request: 'DASHBOARD_MINIVISION_DWELLTIMELINE##REQUEST',
        success: 'DASHBOARD_MINIVISION_DWELLTIMELINE##SUCCESS',
        failure: 'DASHBOARD_MINIVISION_DWELLTIMELINE##FAILURE',
    },
    DASHBOARD_MINIVISION_INTERACTIONS: {
        request: 'DASHBOARD_MINIVISION_INTERACTIONS##REQUEST',
        success: 'DASHBOARD_MINIVISION_INTERACTIONS##SUCCESS',
        failure: 'DASHBOARD_MINIVISION_INTERACTIONS##FAILURE',
    },
    DASHBOARD_MINIVISION_INTERACTIONS_GROUPED: {
        request: 'DASHBOARD_MINIVISION_INTERACTIONS_GROUPED##REQUEST',
        success: 'DASHBOARD_MINIVISION_INTERACTIONS_GROUPED##SUCCESS',
        failure: 'DASHBOARD_MINIVISION_INTERACTIONS_GROUPED##FAILURE',
    },
    DASHBOARD_MINIVISION_STORES_TOP: {
        request: 'DASHBOARD_MINIVISION_STORES_TOP##REQUEST',
        success: 'DASHBOARD_MINIVISION_STORES_TOP##SUCCESS',
        failure: 'DASHBOARD_MINIVISION_STORES_TOP##FAILURE',
    },
    DASHBOARD_MINIVISION_CONTENT_TOP: {
        request: 'DASHBOARD_MINIVISION_CONTENT_TOP##REQUEST',
        success: 'DASHBOARD_MINIVISION_CONTENT_TOP##SUCCESS',
        failure: 'DASHBOARD_MINIVISION_CONTENT_TOP##FAILURE',
    },
}

function fetchMinivisionDwellTimeline(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('minivision/dwelltime/timeline', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_MINIVISION_DWELLTIMELINE.request,
            Types.DASHBOARD_MINIVISION_DWELLTIMELINE.success,
            Types.DASHBOARD_MINIVISION_DWELLTIMELINE.failure,
        ],
    })
}

function fetchMinivisionSoundbarsTop(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('minivision/soundbars/top', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_MINIVISION_SOUNDBARS_TOP.request,
            Types.DASHBOARD_MINIVISION_SOUNDBARS_TOP.success,
            Types.DASHBOARD_MINIVISION_SOUNDBARS_TOP.failure,
        ],
    })
}

function fetchMinivisionInteractions(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('minivision/interactions', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_MINIVISION_INTERACTIONS.request,
            Types.DASHBOARD_MINIVISION_INTERACTIONS.success,
            Types.DASHBOARD_MINIVISION_INTERACTIONS.failure,
        ],
    })
}

function fetchMinivisionInteractionsGrouped(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('minivision/interactions/grouped', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_MINIVISION_INTERACTIONS_GROUPED.request,
            Types.DASHBOARD_MINIVISION_INTERACTIONS_GROUPED.success,
            Types.DASHBOARD_MINIVISION_INTERACTIONS_GROUPED.failure,
        ],
    })
}

function fetchMinivisionStoresTop(from, to) {
    return async (dispatch) => {
        const mainFetch = await dispatch(
            buildAsyncCall({
                endpoint: Helpers.buildUrl('minivision/stores/top', from, to, {
                    count: 5,
                }),
                method: 'GET',
                types: [
                    Types.DASHBOARD_MINIVISION_STORES_TOP.request,
                    Types.DASHBOARD_MINIVISION_STORES_TOP.success,
                    Types.DASHBOARD_MINIVISION_STORES_TOP.failure,
                ],
            })
        )
        const { type, payload } = mainFetch

        if (type !== Types.DASHBOARD_MINIVISION_STORES_TOP.success) {
            return mainFetch
        }

        const promises = await Promise.all(payload.map(({ store_code: storeCode }) => dispatch(Helpers.fetchStore(storeCode))))

        return [mainFetch, ...promises]
    }
}

function fetchMinivisionContentTop(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('minivision/content/top', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_MINIVISION_CONTENT_TOP.request, Types.DASHBOARD_MINIVISION_CONTENT_TOP.success, Types.DASHBOARD_MINIVISION_CONTENT_TOP.failure],
    })
}

export {
    Types,
    fetchMinivisionDwellTimeline,
    fetchMinivisionSoundbarsTop,
    fetchMinivisionInteractions,
    fetchMinivisionInteractionsGrouped,
    fetchMinivisionStoresTop,
    fetchMinivisionContentTop,
}
